type ErrorWithResponse = {
  response?: { status?: number };
};

export const isNotFoundError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as ErrorWithResponse).response?.status === 404;
